class YGCartDrawer extends HTMLElement {
    constructor() {
        super()
        this.init()
    }
    init() {
      this.addEventListener("click", (e) => this.clickDelegation(e))
      document.addEventListener('cart:change', (event) => this.cartChange(event));
    }

    isTargetDom ($clickDom, className){
      // 检查传入的元素是否有效
      if (!$clickDom || !className) {
        return false;
      }

      if($clickDom.closest(`${className}`)) return $clickDom.closest(`${className}`)

      return false
    }

    clickDelegation(e) {
      let $plus = this.isTargetDom(e.target, '.yg-quantity-plus')
      if($plus) {
        this.changeQuantity($plus, 1)
        return 
      }

      let $minus = this.isTargetDom(e.target, '.yg-quantity-minus')
      if($minus) {
        this.changeQuantity($minus, -1)
        return 
      }
    }

    changeQuantity($clickDom, number) {
      let $custom = $clickDom.closest('.yg-quantity')
      let $input = $clickDom.closest('.yg-quantity')?.querySelector('.quantity-input')
      
      if($input) {
        let inputValue = parseInt($input.value) + parseInt(number)
        $input.value = inputValue
        $custom._changeLineItemQuantity($input.getAttribute("data-line-key"), inputValue)
      }
    }

    cartChange(event) {
      let cartData = event.detail.cart; // Get the updated content of the cart
      let baseEvent = event.detail.baseEvent; // Get the base event

      if (cartData.item_count > 0) {
        this.querySelector('.yg-cart-drawer').classList.remove('cart-drawer--empty')
        this.querySelector('.yg-cart-right').classList.remove('hide-pc')
      } else {
        this.querySelector('.yg-cart-drawer').classList.add('cart-drawer--empty')
        this.querySelector('.yg-cart-right').classList.add('hide-pc')
      }
      cartData && this.updateHTMl(".yg-cart-right .horizontal-product-list", cartData.sections[this.getAttribute('data-section-id')])
    }

    updateHTMl (className, doc){
      let $div = document.createElement('div')
    
      $div.innerHTML = doc
      if (Array.isArray(className)) {
        className.forEach((name) => {
          let $old = document.querySelector(name)
          let $new = $div.querySelector(name)
          $old.innerHTML = $new.innerHTML
        })
      } else {
        let $old = document.querySelector(className)
        let $new = $div.querySelector(className)
        $old.innerHTML = $new.innerHTML
      }
    }
}
if (!window.customElements.get('yg-cart-drawer')) {
    window.customElements.define('yg-cart-drawer', YGCartDrawer)
}